import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';

import autobind from 'common/decorators/autobind.js';
import Checkbox from 'core/components/Checkbox.js';
import HealthFundPicker from 'core/components/HealthFundPicker.js';
import Icon from 'core/components/Icon.js';
import {DirectoryStoreContext} from 'core/stores/RootStore.js';

export default
@observer
class HealthFundInfo extends React.Component {
    static contextType = DirectoryStoreContext;

    componentDidMount() {
        this.setPromotedGapSchemeId();
    }

    @autobind
    setPromotedGapSchemeId() {
        const {promotedGapSchemes} = this.props;
        const {
            rootStore: {
                healthFundStore: {healthFund, gapSchemeId},
            },
        } = this.context;
        const promotedGapSchemeId = promotedGapSchemes?.find(
            (pgs) => pgs.healthFundId === healthFund?.id,
        )?.gapSchemeId;
        if (!gapSchemeId && promotedGapSchemeId) {
            this.context.updateStore({
                gapSchemeId: promotedGapSchemeId,
                showOnlyGapScheme: false,
            });
        } else if (gapSchemeId && !promotedGapSchemeId) {
            this.context.updateStore({
                gapSchemeId: null,
            });
        }
    }

    @autobind
    toggleCheckbox() {
        this.context.updateStore({
            showOnlyGapScheme: !this.context.showOnlyGapScheme,
            page: 1,
        });
    }

    @autobind
    toggleInNetworkHospitalCheckbox() {
        this.context.updateStore({
            inNetworkHospitalFilter: !this.context.inNetworkHospitalFilter,
            page: 1,
        });
    }

    renderCheckbox() {
        const {
            showOnlyGapScheme,
            promotedGapSchemePractitionerLength,
            rootStore: {
                healthFundStore: {gapSchemeId},
            },
        } = this.context;
        if (gapSchemeId && promotedGapSchemePractitionerLength) {
            return (
                <ul className="options">
                    <li>
                        <label>
                            <input
                                checked={showOnlyGapScheme}
                                onChange={this.toggleCheckbox}
                                type="checkbox"
                            />
                            <Icon name="checkbox" />
                            {
                                'Only show practitioners offering guaranteed no gap options'
                            }
                        </label>
                    </li>
                </ul>
            );
        }
        return null;
    }

    renderInNetworkHospitalCheckbox() {
        const {
            inNetworkHospitalFilter,
            rootStore: {
                healthFundStore: {healthFund},
            },
        } = this.context;

        return (
            <>
                <span
                    dangerouslySetInnerHTML={{
                        __html: healthFund?.inNetworkPractitionerInformation,
                    }}
                ></span>
                <li className="filters">
                    <Checkbox
                        className="filter"
                        checked={inNetworkHospitalFilter}
                        name="in-network-hospital"
                        onChange={this.toggleInNetworkHospitalCheckbox}
                    >
                        {'In hospital network'}
                    </Checkbox>
                </li>
            </>
        );
    }

    @autobind
    async selectHealthFundHandler(fund) {
        this.context.updateStore({
            page: 1,
        });
        await this.context.rootStore.healthFundStore?.selectHealthFund(
            fund?.id || 0,
        );
        this.setPromotedGapSchemeId();
    }

    render() {
        const {
            specialty: {isMedical},
            rootStore: {
                paramStore: {hasSkin, isClient},
                healthFundStore: {healthFunds, healthFund},
            },
        } = this.context;

        const isHFInfoHidden =
            (hasSkin && !isClient) || healthFunds?.length === 0;
        if (isHFInfoHidden) {
            if (healthFund?.inNetworkHospitalInformation) {
                return (
                    <form
                        aria-selected={!!healthFund?.id}
                        className="filters fund-info fund-relationship-info"
                    >
                        {this.renderInNetworkHospitalCheckbox()}
                    </form>
                );
            } else {
                return null;
            }
        }

        return (
            <HealthFundPicker
                handleSelectHealthFund={this.selectHealthFundHandler}
                initialOptionText={"I don't have private health insurance"}
                isMedical={isMedical}
            >
                {this.renderCheckbox()}
            </HealthFundPicker>
        );
    }
}
